// extracted by css-extract-rspack-plugin
export default {"root":"pYwY5m","context-menu":"qdluQj","contextMenu":"qdluQj","button":"CrCak7"};